import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '@/stores/authStore'
import { getMyCapabilities } from '@/api/roles'

// Only two base roles are predefined; everything else is a dynamic custom role.
export const BUILTIN_ROLES = ['team_member', 'admin']

export const NAV_CAPS: Record<string, string[]> = {
  admin: ['manage_users', 'manage_inventory', 'manage_payroll', 'manage_hr', 'view_analytics', 'manage_leave', 'manage_attendance', 'manage_projects', 'admin_settings'],
  team_member: [],
}

/** Returns a `has(capability)` checker for the current user, plus a loading flag.
 *  Built-in roles resolve synchronously; custom roles fetch their capabilities. */
export function useMyCaps() {
  const role = useAuthStore((s) => s.user?.role)
  const isBuiltin = !!role && BUILTIN_ROLES.includes(role)

  const { data } = useQuery({
    queryKey: ['my-capabilities'],
    queryFn: getMyCapabilities,
    enabled: !!role && !isBuiltin,
    staleTime: 5 * 60_000,
  })

  const caps = new Set<string>(isBuiltin ? (NAV_CAPS[role!] ?? []) : (data?.capabilities ?? []))
  const has = (c: string) => caps.has('admin_settings') || caps.has(c)
  const loading = !!role && !isBuiltin && !data
  return { has, caps, loading, role, isBuiltin }
}
